import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { getAnsweredCallRecap } from "@/store/reports";
import { demoAnsweredCalls } from '@/demoData';

import { appDate } from "@/utils/date";

import { Lead } from '@/types'

import AppPageContainer from "@/components/AppPageContainer";
import AppBox from "@/components/AppBox";
import AppText from "@/components/AppText";
import AppButton from "@/components/AppButton";

const AnsweredCallRecap: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { me } = useAppSelector((state) => state.auth);
  const { answeredCallRecap } = useAppSelector((state) => state.reports as { answeredCallRecap: Lead[] });
  const leads = me.id === 207 ? demoAnsweredCalls : answeredCallRecap;

  const isDemo = me.id === 207;

  useEffect(() => {
    if (!isDemo) {
      dispatch(getAnsweredCallRecap(me.id))
    }
  }, [dispatch, isDemo])

  const handleOpen = (id: number) => {
    navigate(`/lead/${id}`);
  }

  return (
    <AppPageContainer title={`Answered Call Recap (${appDate(new Date().toISOString(), 'M.D.YY')})`}>
      <AppBox column gap={4}>
        {leads?.length ? leads.map((lead, index) => (
          <AppBox key={index} column gap={4} className="bg-white rounded-lg p-4">
            <AppBox gap={2} align="center">
              <AppBox>
                <AppText variant="body">{appDate(lead.created_at)}:</AppText>
              </AppBox>
              
              <AppBox>
                <AppText variant="h5">{lead.name} ({lead.phone})</AppText>
              </AppBox>
            </AppBox>

            <AppBox column gap={2}>
              <AppBox>
                <AppText>Category: {lead.aiCall.bucket}</AppText>
              </AppBox>
              
              <AppBox>
                <AppText>{lead.aiCall.reason}</AppText>
              </AppBox>
              
              <AppBox gap={4}>
                <AppBox width="fit-content">
                  <AppButton variant="primary" size="small" onClick={() => handleOpen(lead.id)}>See Detailed Recap</AppButton>
                </AppBox>
                
                <AppBox width="fit-content">
                  <AppButton variant="secondary" size="small" onClick={() => handleOpen(lead.id)}>Text Lead</AppButton>
                </AppBox>
                
                <AppBox width="fit-content">
                  <AppButton variant="secondary" size="small" onClick={() => handleOpen(lead.id)}>Change status to Lead Booked</AppButton>
                </AppBox>
                
                <AppBox width="fit-content">
                  <AppButton variant="secondary" size="small" onClick={() => handleOpen(lead.id)}>Change status to Lead Archived</AppButton>
                </AppBox>
              </AppBox>
            </AppBox>
          </AppBox>
        )) : 'No Results'}
      </AppBox>
    </AppPageContainer>
  );
};

export default AnsweredCallRecap;